/* eslint-disable vue/script-indent */
<template>
  <div class="toast" v-if="isShowToast">
      <div class="toast_box">
        <div class="toast_box_item">
          <div class="toast_box_img">
            <img src="../../../assets/integrity/icon_ts_gx@3x.png" alt="">
          </div>
          <div class="toast_box_remark">{{ remark }}</div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        props: {
            isShowToast: {
                type: Boolean,
                default: false
            },
            remark: {
                type: String,
                default: null
            }
        },
        watch: {
            'isShowToast' (val) {
                this.isShowToast = val
            }
        }
    }
</script>

<style lang="less" scoped>
  .toast {
    position: fixed;
    width: 100%;
    height:90%;
    display: flex;
    justify-content: center;
    align-items: center;
    .toast_box {
      width:120px;
      height:124px;
      background:rgba(0,0,0,0.7);
      border-radius:4px;
        display: flex;
        justify-content: center;
        align-items: center;
      .toast_box_item{
        text-align: center;
      }
      .toast_box_img {
        margin-left: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 50px;
        height: 50px;
        img {
          display: inline-block;
          width: 100%;
        }
      }
      .toast_box_remark {
        color:rgba(255,255,255,1);
        text-align: center;
        margin-top: 12px;
        font-size:14px;
        font-weight:400;
      }
    }
  }
</style>
